import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function CS_mobile_view_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-6'>1. Cyber Security Concepts</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to cyber security, History of cyber security, Security essential concepts.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-6'>2. Internet & Network</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          History of internet & life cycle, Submarine cable map types of networks, Topologies & Subnet masking, OSI / TCP/ IP Model & address.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-6'>3. Operating System</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Kernel’s & BIOS, Function & architectures of OS.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-6'>4. Introduction to Ethical Hacking</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Ethical hacking & importance, Ethical hacking scope & limitations, Hacker & skills & types, Reasons of hacking & risk of hacking attack, Effects of hacking in organization, Security, functionality, usability triangle.     
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-6'>5. Scanning & Reconnaissance</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Foot printing & objectives, finding company’s details, domain name, internal, URL’S, Server details, domain registration, range of IP address & DNS information, Location of servers & traceroute analysis & email communications, Network scanning & objectives, finding live hosts in a network, SNMP & SMTP & DNS Enumeration, Finding open ports & service on a server, OS
          <br></br><br></br>fingerprinting server banner tools, Vulnerability scanning, Proxy server & work & use, TOR Network & Its use.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-6'>6. Hacking Web server & Web applications</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Web server & applications, Webservers hacked & its consequences, Directory traversal attacks, Website defacement & password brute forcing, cross site scripting.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-6'>7. Sql INJECTION & HIJACKING</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          SQL injection, effects of SQL injection attacks, types, SQL injection detection tools, Session hijacking attacks & defending, DOS & DDOS attack, Dos symptoms & attack techniques, Botnet.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-6'>8. Social engineering& attacks</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Phishing & phishing website, Tricks to access phishing websites, Differentiate phishing & original webpage, Defend against phishing attacks & homograph attack, Firewall & functions & types, IDS & its work, Honeypot & kali linux, Kali linux VS. other linux distributions, Uses of kali linux, Tools for footprinting,scanning,sniffing, Metasploit framework & its use, Using metasploit framework to attack windows.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel9bh-content"
          id="panel9bh-header"
        >
          <Typography className='fs-6'>9. Worms, viruses & Trojans</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Malware & types of malware virus, Virus program and its properties, How Computer infected by virus, Types of virus & tools, Defend against virus attack worm and worm program, Worms different from virus, Trojans & Trojans horse & operating, Defending against Trojans, Spyware & types and defending, Rootkits & types & operating & defending, Sniffer introduction to cloud & Consequences, Mitigation introduction, Symmetric & public & private key.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel10bh-content"
          id="panel10bh-header"
        >
          <Typography className='fs-6'>10. System hacking & Security</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          System hacking & goals, Password cracking & complexity, Default password of network devices & softwares, Password cracking methods online & offline, MIM attack, Brute forcing & dictionary based cracking, Usb passwords stealers, Elcomsoft distributed password recovery tools, Active password changer, Keylogger & deploy to remote pc & defending, Mobile hacking & goals, Countermeasures & sniffers & its works, Types & active & passive in sniffing, ARP & Posio attack, Threats of ARP poison attack, MAC Spoofing works & flooding, Defend against MAC spoofing attack, Defend against sniffers in network, Wireless network & types, Wifi network & types of wifi authentications, Using a centralized authentication server & local authentication, Types of encryption network( WEP/ WPA/ WPA2), Hardware & software required to crack wi-fi networks, Cracking of WEP/ WPA/WPA2 Encryption, Defend against Wifi cracking attack.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel11'} onChange={handleChange('panel11')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel11bh-content"
          id="panel11bh-header"
        >
          <Typography className='fs-6'>11. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project Overview
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
